import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6980efd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Shipping address change requires full or part VAT refund.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If confirmed, you must refund the customer the correct amount.", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Shipping address change requires full or part VAT recharge.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If confirmed, you must recharge the customer the correct amount. You must first agree this with the customer. ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { ref: "popupContainer" }
const _hoisted_10 = { class: "k-form" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Shipping Details", -1))
const _hoisted_12 = { class: "k-form-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Company Name ", -1))
const _hoisted_14 = { class: "k-form-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Company Registration No ", -1))
const _hoisted_16 = { class: "k-form-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "First Name", -1))
const _hoisted_18 = { class: "k-form-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Last Name", -1))
const _hoisted_20 = { class: "k-form-field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Country", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "k-form-field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "County", -1))
const _hoisted_25 = { class: "k-form-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Line1", -1))
const _hoisted_27 = { class: "k-form-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Line2", -1))
const _hoisted_29 = { class: "k-form-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Town", -1))
const _hoisted_31 = { class: "k-form-field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Post Code", -1))
const _hoisted_33 = { class: "k-form-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Phone Number", -1))
const _hoisted_35 = { class: "k-form-field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Is Eu", -1))
const _hoisted_37 = { class: "k-form-field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Is Uk For VAT", -1))
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = {
  key: 1,
  class: "container"
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-7" }
const _hoisted_43 = { class: "row text-start fs-4" }
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = {
  key: 0,
  class: "extra-care"
}
const _hoisted_46 = {
  key: 1,
  class: "redo-span"
}
const _hoisted_47 = {
  key: 2,
  class: "refund-recharge-span"
}
const _hoisted_48 = {
  key: 3,
  class: "refund-recharge-span"
}
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-xs-12" }
const _hoisted_51 = { class: "row text-start mt-2" }
const _hoisted_52 = { class: "col-12 justify-content-space-between" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "row mt-2 text-start" }
const _hoisted_56 = { class: "col-12 justify-content-space-between" }
const _hoisted_57 = {
  key: 0,
  class: "row mt-1"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Parent redo order:", -1))
const _hoisted_59 = { class: "col-8 text-start" }
const _hoisted_60 = {
  key: 1,
  class: "row mt-1"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Child redo orders:", -1))
const _hoisted_62 = { class: "col-8 text-start redo-childrens-container" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Customer:", -1))
const _hoisted_65 = { class: "col-8 text-start" }
const _hoisted_66 = { class: "row mt-1" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Email:", -1))
const _hoisted_68 = { class: "col-8 text-start" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-plus" }, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "font-weight-bold" }
const _hoisted_72 = {
  key: 2,
  class: "row mt-1"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "External Reference:", -1))
const _hoisted_74 = { class: "col-8 text-start" }
const _hoisted_75 = { class: "row mt-1" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Mobile:", -1))
const _hoisted_77 = { class: "col-8 text-start" }
const _hoisted_78 = {
  key: 3,
  class: "row mt-1"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Owner:", -1))
const _hoisted_80 = { class: "col-8 text-start" }
const _hoisted_81 = {
  key: 4,
  class: "row mt-1"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Owner Email:", -1))
const _hoisted_83 = { class: "col-8 text-start" }
const _hoisted_84 = { class: "font-weight-bold" }
const _hoisted_85 = { class: "row mt-1" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Status:", -1))
const _hoisted_87 = ["value", "disabled"]
const _hoisted_88 = {
  key: 0,
  class: "col-2"
}
const _hoisted_89 = {
  key: 5,
  class: "row mt-1"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Latest Relay Status:", -1))
const _hoisted_91 = { class: "col-8 text-start latest-relay-status" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "k-icon k-i-exclamation-circle",
  title: "{{order.LatestRelayStatus.ExceptionMessage}}"
}, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_94 = {
  key: 6,
  class: "row mt-1"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Tracking number:", -1))
const _hoisted_96 = { class: "col-8 text-start tracking-number" }
const _hoisted_97 = ["required"]
const _hoisted_98 = { class: "row mt-1" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Billing Address:", -1))
const _hoisted_100 = { class: "col-8 text-start" }
const _hoisted_101 = ["value"]
const _hoisted_102 = { class: "row mt-1" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Shipping Address:", -1))
const _hoisted_104 = { class: "col-8 text-start" }
const _hoisted_105 = ["value"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-plus" }, null, -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-edit" }, null, -1))
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = {
  key: 7,
  class: "row mt-1"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Customs Code:", -1))
const _hoisted_112 = { class: "col-8 text-start" }
const _hoisted_113 = { class: "col-4 text-start" }
const _hoisted_114 = { class: "col-8 text-start" }
const _hoisted_115 = { class: "row mt-1" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Option:", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: ""
}, "Select a delivery option", -1))
const _hoisted_118 = ["value"]
const _hoisted_119 = { class: "row mt-1" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Production Branch:", -1))
const _hoisted_121 = { class: "col-8 text-start" }
const _hoisted_122 = ["value"]
const _hoisted_123 = { class: "row mt-1" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Branch:", -1))
const _hoisted_125 = { class: "col-8 text-start" }
const _hoisted_126 = ["value"]
const _hoisted_127 = {
  key: 8,
  class: "row mt-1"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Relay Branch:", -1))
const _hoisted_129 = { class: "col-8 text-start" }
const _hoisted_130 = {
  key: 9,
  class: "row mt-1"
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "USA Type:", -1))
const _hoisted_132 = { class: "col-8 text-start" }
const _hoisted_133 = { class: "row mt-1" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Order Date:", -1))
const _hoisted_135 = { class: "col-8 text-start" }
const _hoisted_136 = {
  key: 10,
  class: "row mt-1"
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Effective Date:", -1))
const _hoisted_138 = { class: "col-8 text-start" }
const _hoisted_139 = {
  key: 11,
  class: "row mt-1"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Bulk Dispatch Received:", -1))
const _hoisted_141 = { class: "col-8 text-start" }
const _hoisted_142 = {
  key: 12,
  class: "row mt-1"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, " Start Mounting or Framing date: ", -1))
const _hoisted_144 = { class: "col-8 text-start" }
const _hoisted_145 = { class: "row mt-1" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Due Date:", -1))
const _hoisted_147 = { class: "col-8 text-start" }
const _hoisted_148 = {
  key: 13,
  class: "row mt-1"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Printed Date:", -1))
const _hoisted_150 = { class: "col-8 text-start" }
const _hoisted_151 = {
  key: 14,
  class: "row mt-1"
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Dispatched Date:", -1))
const _hoisted_153 = { class: "col-8 text-start" }
const _hoisted_154 = {
  key: 15,
  class: "row mt-1"
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Ready For Collection Date:", -1))
const _hoisted_156 = { class: "col-8 text-start" }
const _hoisted_157 = { class: "row mt-1" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Total Excluding VAT:", -1))
const _hoisted_159 = { class: "col-8 text-start" }
const _hoisted_160 = { class: "row mt-1" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Delivery Charge:", -1))
const _hoisted_162 = { class: "col-8 text-start" }
const _hoisted_163 = { class: "row mt-1" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "VAT:", -1))
const _hoisted_165 = { class: "col-8 text-start" }
const _hoisted_166 = { class: "row mt-1" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Total Including VAT:", -1))
const _hoisted_168 = { class: "col-8 text-start" }
const _hoisted_169 = { class: "row mt-1" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Last Edited:", -1))
const _hoisted_171 = { class: "col-8 text-start" }
const _hoisted_172 = { class: "row mt-1" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Last Edited By:", -1))
const _hoisted_174 = { class: "col-8 text-start" }
const _hoisted_175 = {
  key: 16,
  class: "row mt-1"
}
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Paid Type:", -1))
const _hoisted_177 = { class: "col-8 text-start" }
const _hoisted_178 = {
  key: 17,
  class: "row mt-1"
}
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Payment Date:", -1))
const _hoisted_180 = { class: "col-8 text-start" }
const _hoisted_181 = {
  key: 18,
  class: "row mt-1"
}
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Manual Payment Method:", -1))
const _hoisted_183 = { class: "col-8 text-start" }
const _hoisted_184 = {
  key: 19,
  class: "row mt-1"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Dispatch Quality Control By:", -1))
const _hoisted_186 = { class: "col-8 text-start" }
const _hoisted_187 = {
  key: 20,
  class: "row mt-1"
}
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Print Quality Control By:", -1))
const _hoisted_189 = { class: "col-8 text-start" }
const _hoisted_190 = {
  key: 21,
  class: "row mt-1"
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, " Mounting/Framing Quality Control By: ", -1))
const _hoisted_192 = { class: "col-8 text-start" }
const _hoisted_193 = { class: "row mt-1" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "Total Copies:", -1))
const _hoisted_195 = { class: "col-8 text-start" }
const _hoisted_196 = { class: "row mt-1" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, "CreativeHub Book Included:", -1))
const _hoisted_198 = { class: "col-8 text-start" }
const _hoisted_199 = { class: "row mt-1" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end fw-bold" }, " Message to lab From Customer: ", -1))
const _hoisted_201 = { class: "col-8 text-start" }
const _hoisted_202 = { class: "col-5 text-start" }
const _hoisted_203 = { class: "row" }
const _hoisted_204 = { class: "order-navigation-contatiner" }
const _hoisted_205 = ["disabled"]
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-arrow-chevron-left" }, null, -1))
const _hoisted_207 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Last Order"))
const _hoisted_208 = [
  _hoisted_206,
  _hoisted_207
]
const _hoisted_209 = ["disabled"]
const _hoisted_210 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Next Order") + " ")
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-arrow-chevron-right" }, null, -1))
const _hoisted_212 = [
  _hoisted_210,
  _hoisted_211
]
const _hoisted_213 = { class: "row my-2" }
const _hoisted_214 = { class: "col-xs-12" }
const _hoisted_215 = { class: "col-xs-12" }
const _hoisted_216 = { class: "col-xs-12" }
const _hoisted_217 = { class: "col-xs-12" }
const _hoisted_218 = { class: "col-xs-12" }
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-2 bold" }, "Error Messages", -1))
const _hoisted_220 = { class: "row my-2" }
const _hoisted_221 = {
  key: 1,
  class: "refund-table-contrainer"
}
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "refund-table-title" }, "Existing Actions", -1))
const _hoisted_223 = { class: "refund-table refun-table-font-size" }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "refund-table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Action"),
  /*#__PURE__*/_createElementVNode("th", null, "Amount"),
  /*#__PURE__*/_createElementVNode("th", null, "Quantity"),
  /*#__PURE__*/_createElementVNode("th", null, "Note"),
  /*#__PURE__*/_createElementVNode("th", null, "Invoice")
], -1))
const _hoisted_225 = { key: 0 }
const _hoisted_226 = { key: 0 }
const _hoisted_227 = { key: 0 }
const _hoisted_228 = ["onClick"]
const _hoisted_229 = ["onClick"]
const _hoisted_230 = {
  key: 2,
  class: "container-fluid"
}
const _hoisted_231 = { class: "d-flex" }
const _hoisted_232 = { class: "d-flex" }
const _hoisted_233 = {
  key: 0,
  class: "d-flex m-2 align-items-center"
}
const _hoisted_234 = ["value"]
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "refundRechrgeTotal",
  class: "p-1"
}, "Total: ", -1))
const _hoisted_236 = { class: "refund-total-input-container" }
const _hoisted_237 = { class: "refund-total-input-currency" }
const _hoisted_238 = ["max"]
const _hoisted_239 = {
  key: 1,
  class: "d-flex m-2 align-items-center"
}
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "shouldUpdateCourier",
  class: "p-1"
}, "Upgrade to courier: ", -1))
const _hoisted_241 = { class: "d-flex m-2" }
const _hoisted_242 = ["value"]
const _hoisted_243 = {
  key: 0,
  class: "d-flex m-2"
}
const _hoisted_244 = ["value"]
const _hoisted_245 = {
  key: 1,
  class: "d-flex m-2"
}
const _hoisted_246 = ["disabled"]
const _hoisted_247 = { class: "row mt-4" }
const _hoisted_248 = { class: "col-12" }
const _hoisted_249 = { class: "table table-bordered" }
const _hoisted_250 = ["colspan"]
const _hoisted_251 = { key: 0 }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Image", -1))
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Quantity", -1))
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Print Type", -1))
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Paper", -1))
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Print Dimensions", -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Border", -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Printed area", -1))
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Finishing", -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Finishing Details", -1))
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Price Excluding VAT", -1))
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "VAT", -1))
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Price Including VAT", -1))
const _hoisted_264 = { key: 0 }
const _hoisted_265 = ["onUpdate:modelValue"]
const _hoisted_266 = ["src", "alt"]
const _hoisted_267 = { key: 1 }
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "non printable asset", -1))
const _hoisted_269 = [
  _hoisted_268
]
const _hoisted_270 = ["onClick"]
const _hoisted_271 = {
  key: 3,
  class: "download-assets"
}
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Download assets", -1))
const _hoisted_273 = ["href"]
const _hoisted_274 = { key: 0 }
const _hoisted_275 = ["href"]
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Printable files:", -1))
const _hoisted_277 = ["href"]
const _hoisted_278 = ["onUpdate:modelValue", "max"]
const _hoisted_279 = { key: 1 }
const _hoisted_280 = { key: 0 }
const _hoisted_281 = { key: 1 }
const _hoisted_282 = { key: 0 }
const _hoisted_283 = { key: 1 }
const _hoisted_284 = { key: 0 }
const _hoisted_285 = { key: 1 }
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "top: ", -1))
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "right: ", -1))
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "bottom: ", -1))
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "left: ", -1))
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_294 = { key: 0 }
const _hoisted_295 = { key: 1 }
const _hoisted_296 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_297 = { key: 0 }
const _hoisted_298 = /*#__PURE__*/_createTextVNode(" Include delivery ")
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: 9,
  class: "text-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "pull-right fw-bold" }, "TOTALS:")
], -1))
const _hoisted_300 = { class: "fw-bold" }
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_302 = /*#__PURE__*/_createTextVNode(" + Delivery ")
const _hoisted_303 = { class: "fw-bold" }
const _hoisted_304 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_GenericModalVue = _resolveComponent("GenericModalVue")!
  const _component_GenericMessageModal = _resolveComponent("GenericMessageModal")!
  const _component_GenericConfirmModal = _resolveComponent("GenericConfirmModal")!
  const _component_DispatchQCModalVue = _resolveComponent("DispatchQCModalVue")!
  const _component_OrderHistoryModalVue = _resolveComponent("OrderHistoryModalVue")!
  const _component_PreventUnpaidStatusSelectModalVue = _resolveComponent("PreventUnpaidStatusSelectModalVue")!
  const _component_OrderNftsModal = _resolveComponent("OrderNftsModal")!
  const _component_kinput = _resolveComponent("kinput")!
  const _component_k_checkbox = _resolveComponent("k-checkbox")!
  const _component_kwindow = _resolveComponent("kwindow")!
  const _component_OrderSubHeader = _resolveComponent("OrderSubHeader")!
  const _component_KTooltip = _resolveComponent("KTooltip")!
  const _component_notes_list = _resolveComponent("notes-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_GenericModalVue, {
        show: _ctx.showGenericModal,
        "body-text": _ctx.modalBodyText,
        "header-text": 'WARNING!!!',
        "is-question": true,
        "is-warning": true,
        "select-list": _ctx.modalSelectList,
        onClose: _ctx.onCloseModal
      }, null, 8, ["show", "body-text", "select-list", "onClose"]),
      _createVNode(_component_GenericMessageModal, {
        show: _ctx.showBulkModal,
        "body-text": 'Please place in a USA bulk dispatch tray',
        "header-text": 'WARNING!!!',
        "is-warning": true,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBulkModal = false))
      }, null, 8, ["show"]),
      _createVNode(_component_GenericConfirmModal, {
        show: _ctx.show,
        title: _ctx.title,
        "body-text": _ctx.vatStatusChangedText,
        onClosed: _ctx.onConfirmModalClosed,
        onCancelled: _ctx.onConfirmModalCancelled,
        onConfirmed: _ctx.onConfirmModalConfirmed
      }, {
        main: _withCtx(() => [
          (_ctx.vatStatus == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.vatStatus == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["show", "title", "body-text", "onClosed", "onCancelled", "onConfirmed"]),
      _createVNode(_component_DispatchQCModalVue, {
        show: _ctx.showDispatchQCModal,
        "qc-users": _ctx.modalSelectList,
        order: _ctx.order,
        onCancel: _ctx.onCancelDispatchQCModal,
        onConfirm: _ctx.onConfirmDispatchQCModal
      }, null, 8, ["show", "qc-users", "order", "onCancel", "onConfirm"]),
      _createVNode(_component_OrderHistoryModalVue, {
        show: _ctx.showOrderHistoryModal,
        "select-list": _ctx.order.OrderStatusHistory,
        onClose: _ctx.onOrderHistoryCloseModal
      }, null, 8, ["show", "select-list", "onClose"]),
      _createVNode(_component_PreventUnpaidStatusSelectModalVue, {
        show: _ctx.showPreventUnpdaidStatusSelectModal,
        "allows-invoicing": _ctx.order.UserIsForInvoice,
        users: _ctx.modalSelectList,
        onClose: _ctx.onClosePreventUnpaidModal
      }, null, 8, ["show", "allows-invoicing", "users", "onClose"]),
      _createVNode(_component_OrderNftsModal, {
        show: _ctx.showOrderNftsModal,
        "order-id": _ctx.$route.params.orderId,
        onClose: _ctx.onCloseOrderNftsModal
      }, null, 8, ["show", "order-id", "onClose"]),
      _createElementVNode("div", _hoisted_9, null, 512)
    ])),
    (_ctx.addEditShippingAddressVisible)
      ? (_openBlock(), _createBlock(_component_kwindow, {
          key: 0,
          title: 'Shipping Address',
          "maximize-button": () => null,
          "minimize-button": () => null,
          "initial-height": 700,
          "initial-width": 400,
          onClose: _ctx.closeUpsertShippingAddressWindow
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", _hoisted_10, [
              _createElementVNode("fieldset", null, [
                _hoisted_11,
                _createElementVNode("label", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.CompanyName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uspsertShippingAddressModel.CompanyName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.CompanyRegistrationNo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uspsertShippingAddressModel.CompanyRegistrationNo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.FirstName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.uspsertShippingAddressModel.FirstName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.LastName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.uspsertShippingAddressModel.LastName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.uspsertShippingAddressModel.CountryId) = $event)),
                    class: "form-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uspsertShippingAddressCountries, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.Id,
                        value: item.Id
                      }, _toDisplayString(item.Name), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.uspsertShippingAddressModel.CountryId]
                  ])
                ]),
                _createElementVNode("label", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.County,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uspsertShippingAddressModel.County) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.Line1,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.uspsertShippingAddressModel.Line1) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.Line2,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uspsertShippingAddressModel.Line2) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.Town,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uspsertShippingAddressModel.Town) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.PostCode,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.uspsertShippingAddressModel.PostCode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_kinput, {
                    modelValue: _ctx.uspsertShippingAddressModel.PhoneNumber,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.uspsertShippingAddressModel.PhoneNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_k_checkbox, {
                    modelValue: _ctx.uspsertShippingAddressModel.IsEu,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.uspsertShippingAddressModel.IsEu) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("label", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_k_checkbox, {
                    modelValue: _ctx.uspsertShippingAddressModel.IsUkForVAT,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.uspsertShippingAddressModel.IsUkForVAT) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  class: "btn btn-secondary m-2",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeUpsertShippingAddressWindow && _ctx.closeUpsertShippingAddressWindow(...args)))
                }, " Cancel "),
                _createElementVNode("button", {
                  class: "btn btn-primary m-2",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.submitUpsertShippingAddress && _ctx.submitUpsertShippingAddress(...args)))
                }, " Submit ")
              ])
            ])
          ]),
          _: 1
        }, 8, ["maximize-button", "minimize-button", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.order.Id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", null, _toDisplayString(`Order No: ${_ctx.order.Id}`) + " " + _toDisplayString(_ctx.orderDisplayType), 1),
                  (_ctx.order.IsExtraCare)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, "EXTRA CARE"))
                    : _createCommentVNode("", true),
                  (_ctx.order.IsRedoOrder)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, "RE-DO"))
                    : _createCommentVNode("", true),
                  (_ctx.order.HasRefund)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, "HAS REFUND"))
                    : _createCommentVNode("", true),
                  (_ctx.order.HasRecharge)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, "HAS RECHARGE"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_OrderSubHeader, { order: _ctx.order }, null, 8, ["order"])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("button", {
                    class: "btn btn-warning m-2",
                    disabled: !_ctx.hasDeliveryOption,
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateOrder()))
                  }, " Update Order ", 8, _hoisted_53),
                  _createElementVNode("button", {
                    class: "btn btn-warning m-2",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onViewOrderStatusHistoryClick()))
                  }, " View Order History "),
                  (_ctx.isBulkDispatchStatus)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-danger m-2",
                        disabled: _ctx.hasBulkDispatchReceived,
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onBulkDispatchReceivedClick()))
                      }, " Bulk Dispatch Received ", 8, _hoisted_54))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("button", {
                    class: "btn btn-warning m-2",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.printShippingLabel()))
                  }, " Picking Label "),
                  (_ctx.isMagnumOrder)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-warning m-2",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.printMagnumPickingLabel()))
                      }, " Picking Label To "))
                    : _createCommentVNode("", true),
                  (
                _ctx.enableShippyProShipmentsCreation &&
                (_ctx.inDispatchOrDispatched || _ctx.inDispatchQC)
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-warning m-2",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.printShippyProShippingLabel()))
                      }, " Shipping Label "))
                    : _createCommentVNode("", true),
                  (
                _ctx.enableShippyProShipmentsCreation &&
                (_ctx.inDispatchOrDispatched || _ctx.inDispatchQC) &&
                _ctx.order.CommercialInvoiceAvailable
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-warning m-2",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.printCustomsInvoice()))
                      }, " Customs Invoice "))
                    : _createCommentVNode("", true),
                  (_ctx.hasInserts)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "btn btn-warning m-2",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.downloadInserts()))
                      }, " Inserts "))
                    : _createCommentVNode("", true),
                  (_ctx.order.BrandedDeliveryFileId != null)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 4,
                        class: "btn btn-warning m-2",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.downloadBrandedDeliveryFile()))
                      }, " Branded Delivery "))
                    : _createCommentVNode("", true),
                  (_ctx.order.HasAuthenticityCertificates)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        class: "btn btn-warning m-2",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.downloadCertificates()))
                      }, " Certificates "))
                    : _createCommentVNode("", true),
                  (_ctx.order.HasNftCertificates)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        class: "btn btn-warning m-2",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.listNftCertificates()))
                      }, " Nfts "))
                    : _createCommentVNode("", true),
                  (_ctx.hasCutFile)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 7,
                        class: "btn btn-warning m-2",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.downloadCutfile()))
                      }, " Cut File "))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.order.IsRedoOrder)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("a", {
                        rel: "stylesheet",
                        class: "redo-link",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.goToPage(`/orders/${_ctx.order.ParentOrderId}`)))
                      }, "Open ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.ChildrenOrdersIds.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.ChildrenOrdersIds, (orderId) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: orderId,
                          rel: "stylesheet",
                          class: "redo-link",
                          onClick: ($event: any) => (_ctx.goToPage(`/orders/${orderId}`))
                        }, "Open " + _toDisplayString(orderId), 9, _hoisted_63))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["row", _ctx.order.IsRedoOrder ? 'mt-1' : 'mt-4'])
              }, [
                _hoisted_64,
                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.order.UserFullName), 1)
              ], 2),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, [
                  (
                _ctx.isAlternativeEmailFunctionAvailable && !_ctx.order.AlternativeEmail
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-warning ms-2 copy-selection",
                        title: "Add Alternative Email",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.editAlternativeEmail()))
                      }, _hoisted_70))
                    : _createCommentVNode("", true),
                  (
                _ctx.isAlternativeEmailFunctionAvailable && _ctx.order.AlternativeEmail
              )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "active-selector",
                        title: "Alternative Email",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.editAlternativeEmail()))
                      }, _toDisplayString(_ctx.order.AlternativeEmail), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.order.Email) + " ", 1),
                  _createElementVNode("span", _hoisted_71, "(" + _toDisplayString(_ctx.order.SpendCategory) + ")", 1)
                ])
              ]),
              (_ctx.order.ExternalReference)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.order.ExternalReference), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.order.Mobile), 1)
              ]),
              (_ctx.order.OwnerFullName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.order.OwnerFullName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.OwnerEmail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _createTextVNode(_toDisplayString(_ctx.order.OwnerEmail) + " ", 1),
                      _createElementVNode("span", _hoisted_84, "(" + _toDisplayString(_ctx.ownerCategories) + ")", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("div", {
                  class: _normalizeClass(["text-start", _ctx.isStatusChanged ? 'col-6' : 'col-8'])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.order.CurrentStatus) = $event)),
                    class: "form-select",
                    onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.onStatusChange && _ctx.onStatusChange(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrderStatusOptions, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.Id,
                        value: item.Id,
                        disabled: _ctx.setDisableToOrderStatuses(item)
                      }, _toDisplayString(item.Name), 9, _hoisted_87))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.order.CurrentStatus]
                  ])
                ], 2),
                (_ctx.isStatusChanged)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("button", {
                        class: "btn btn-warning mb-1 ml-1",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.updateOrder()))
                      }, " Update ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.order.LatestRelayStatus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getRelayStatusText(_ctx.order.LatestRelayStatus.RelayStatus)), 1),
                      _createVNode(_component_KTooltip, {
                        "anchor-element": 'target',
                        content: 'myTooltipTemplate',
                        position: 'right'
                      }, {
                        myTooltipTemplate: _withCtx(() => [
                          _createElementVNode("span", null, "Timestamp: " + _toDisplayString(_ctx.order.LatestRelayStatus.Timestamp), 1),
                          _hoisted_93,
                          _createElementVNode("span", null, "Details: " + _toDisplayString(_ctx.order.LatestRelayStatus.ExceptionMessage), 1)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_92
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.Status === 11)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _hoisted_95,
                    _createElementVNode("div", _hoisted_96, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.order.TrackingNumber) = $event)),
                        class: "form-control",
                        required: !_ctx.order.TrackingNumber
                      }, null, 8, _hoisted_97), [
                        [_vModelText, _ctx.order.TrackingNumber]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_98, [
                _hoisted_99,
                _createElementVNode("div", _hoisted_100, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.order.BillingAddressId) = $event)),
                    class: "form-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.BillingAddresses, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.Id,
                        value: item.Id
                      }, _toDisplayString(item.AddressOnOneLine), 9, _hoisted_101))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.order.BillingAddressId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("div", _hoisted_104, [
                  _withDirectives(_createElementVNode("select", {
                    id: "shipping-address",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.order.ShippingAddressId) = $event)),
                    class: "form-select",
                    onChange: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.onShippingAddressChanged && _ctx.onShippingAddressChanged(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.ShippingAddresses, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.Id,
                        value: item.Id
                      }, _toDisplayString(item.AddressOnOneLine), 9, _hoisted_105))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.order.ShippingAddressId]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-warning ms-2 copy-selection",
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.copySelection()))
                  }, " copy selection "),
                  (!_ctx.order.ShippingAddressId || _ctx.order.OrderTypeId !== 11)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-warning ms-2 copy-selection",
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onAddNewAddressClick()))
                      }, _hoisted_107))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-warning ms-2 copy-selection",
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onEditAddressClick()))
                  }, _hoisted_109)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderDeliveryErrors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'deliveryErrorMsg_' + index,
                  class: "row mt-1 alert alert-danger"
                }, _toDisplayString(error.Message), 1))
              }), 128)),
              (_ctx.CustomsCodeJSON != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("div", _hoisted_112, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CustomsCodeHeadings, (propertyName) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: propertyName,
                          class: "row mt-1"
                        }, [
                          _createElementVNode("div", _hoisted_113, _toDisplayString(propertyName), 1),
                          _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.CustomsCodeJSON[propertyName]), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_115, [
                _hoisted_116,
                _createElementVNode("div", {
                  class: _normalizeClass(["col-8 text-start", { missing: !_ctx.hasDeliveryOption }])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.order.DeliveryOptionId) = $event)),
                    class: "form-select"
                  }, [
                    _hoisted_117,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryOptions, (deliveryOption) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: deliveryOption.Id,
                        value: deliveryOption.Id
                      }, _toDisplayString(deliveryOption.Name), 9, _hoisted_118))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.order.DeliveryOptionId]
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_119, [
                _hoisted_120,
                _createElementVNode("div", _hoisted_121, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.order.DeliveryBranchId) = $event)),
                    class: "form-select"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryBranches, (branch) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: branch.Id,
                        value: branch.Id
                      }, _toDisplayString(branch.Name), 9, _hoisted_122))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.order.DeliveryBranchId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_123, [
                _hoisted_124,
                _createElementVNode("div", _hoisted_125, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.order.ProductionBranchId) = $event)),
                    class: "form-select",
                    onChange: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.onDeliverBranchChanged && _ctx.onDeliverBranchChanged(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryBranches, (branch) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: branch.Id,
                        value: branch.Id
                      }, _toDisplayString(branch.Name), 9, _hoisted_126))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.order.ProductionBranchId]
                  ])
                ])
              ]),
              (_ctx.order.IsRelayRerouted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                    _hoisted_128,
                    _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.branchDescription(_ctx.order.RelayBranchId)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.USAType > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                    _hoisted_131,
                    _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.USAType), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_133, [
                _hoisted_134,
                _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.order.OrderDate), 1)
              ]),
              (_ctx.order.PaidDate != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                    _hoisted_137,
                    _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.order.PaidDate), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasBulkDispatchReceived)
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                    _hoisted_140,
                    _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.order.BulkDispatchReceivedDate) + ", set by " + _toDisplayString(_ctx.order.BulkDispatchReceivedUser), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.StartMountingOrFramingDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                    _hoisted_143,
                    _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.order.StartMountingOrFramingDate), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_145, [
                _hoisted_146,
                _createElementVNode("div", _hoisted_147, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.order.DueDate) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.order.DueDate]
                  ])
                ])
              ]),
              (_ctx.order.DatePrinted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    _hoisted_149,
                    _createElementVNode("div", _hoisted_150, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.order.DatePrinted) = $event)),
                        class: "form-control",
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.order.DatePrinted]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.DispatchDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _hoisted_152,
                    _createElementVNode("div", _hoisted_153, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.order.DispatchDate) = $event)),
                        class: "form-control",
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.order.DispatchDate]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.ReadyForCollectionDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                    _hoisted_155,
                    _createElementVNode("div", _hoisted_156, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.order.ReadyForCollectionDate) = $event)),
                        class: "form-control",
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.order.ReadyForCollectionDate]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_157, [
                _hoisted_158,
                _createElementVNode("div", _hoisted_159, _toDisplayString(_ctx.order.CurrencySymbol + _ctx.order.TotalExcludingVat?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_160, [
                _hoisted_161,
                _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.order.CurrencySymbol + _ctx.order.DeliveryCharge?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_163, [
                _hoisted_164,
                _createElementVNode("div", _hoisted_165, _toDisplayString(_ctx.order.CurrencySymbol + _ctx.order.Vat?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_166, [
                _hoisted_167,
                _createElementVNode("div", _hoisted_168, _toDisplayString(_ctx.order.CurrencySymbol + _ctx.order.TotalIncludingVat?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_169, [
                _hoisted_170,
                _createElementVNode("div", _hoisted_171, _toDisplayString(_ctx.order.LastEditDate), 1)
              ]),
              _createElementVNode("div", _hoisted_172, [
                _hoisted_173,
                _createElementVNode("div", _hoisted_174, _toDisplayString(_ctx.order.LastEditedBy), 1)
              ]),
              (_ctx.getPaidType())
                ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                    _hoisted_176,
                    _createElementVNode("div", _hoisted_177, _toDisplayString(_ctx.getPaidType()), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.PaidDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                    _hoisted_179,
                    _createElementVNode("div", _hoisted_180, _toDisplayString(_ctx.order.PaidDate), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.ManualPaymentMethod && _ctx.getPaidType())
                ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                    _hoisted_182,
                    _createElementVNode("div", _hoisted_183, _toDisplayString(_ctx.getManualPaymentMethod(_ctx.order.ManualPaymentMethod)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.DispatchQCUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                    _hoisted_185,
                    _createElementVNode("div", _hoisted_186, _toDisplayString(_ctx.order.DispatchQCUser.FullName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.PrintQCUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                    _hoisted_188,
                    _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.order.PrintQCUser.FullName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.FramingMountingQCUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                    _hoisted_191,
                    _createElementVNode("div", _hoisted_192, _toDisplayString(_ctx.order.FramingMountingQCUser.FullName), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_193, [
                _hoisted_194,
                _createElementVNode("div", _hoisted_195, _toDisplayString(_ctx.order.TotalItems), 1)
              ]),
              _createElementVNode("div", _hoisted_196, [
                _hoisted_197,
                _createElementVNode("div", _hoisted_198, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.order.HasTPSBook) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.order.HasTPSBook]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_199, [
                _hoisted_200,
                _createElementVNode("div", _hoisted_201, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.order.MessageToLab) = $event)),
                    class: "messageToLab",
                    type: "textarea",
                    readonly: "",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.order.MessageToLab]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_202, [
              _createElementVNode("div", _hoisted_203, [
                _createElementVNode("div", _hoisted_204, [
                  _createElementVNode("button", {
                    class: "btn btn-primary m-2",
                    disabled: _ctx.order.LastOrderId == null,
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.onLastOrderClick()))
                  }, _hoisted_208, 8, _hoisted_205),
                  _createElementVNode("button", {
                    class: "btn btn-primary m-2",
                    disabled: _ctx.order.NextOrderId == null,
                    onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onNextOrderClick()))
                  }, _hoisted_212, 8, _hoisted_209)
                ])
              ]),
              _createElementVNode("div", _hoisted_213, [
                _createElementVNode("div", _hoisted_214, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mb-2",
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.viewJobSheet()))
                  }, " View Job Sheet ")
                ]),
                _createElementVNode("div", _hoisted_215, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mb-2",
                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.emailInvoiceToCustomer($event)))
                  }, " Email Invoice To Customer ")
                ]),
                _createElementVNode("div", _hoisted_216, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mb-2",
                    onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.viewInvoice()))
                  }, " View Invoice ")
                ]),
                _createElementVNode("div", _hoisted_217, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mb-2",
                    onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.goToCustomer()))
                  }, " Edit Customer ")
                ]),
                _createElementVNode("div", _hoisted_218, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mb-2",
                    onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.download()))
                  }, " Push to Relay ")
                ])
              ]),
              (_ctx.hasErrorMessages)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_219,
                    _createElementVNode("ul", _hoisted_220, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.ErrorMessages, (msg, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: 'code_' + index,
                          class: "col-xs-12 red"
                        }, _toDisplayString(msg), 1))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_notes_list, {
                notes: _ctx.notes,
                type: _ctx.OrderNoteType.Order,
                "parent-id": _ctx.order.Id,
                "customer-id": _ctx.order.UserId,
                onNoteAdded: _ctx.noteAdded,
                onNoteUpdated: _ctx.noteUpdated,
                onNoteDeleted: _ctx.noteDeleted
              }, null, 8, ["notes", "type", "parent-id", "customer-id", "onNoteAdded", "onNoteUpdated", "onNoteDeleted"]),
              (_ctx.order.RefundRecharges.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                    _hoisted_222,
                    _createElementVNode("table", _hoisted_223, [
                      _hoisted_224,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.RefundRecharges, (refund) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: refund.Id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(refund.Date), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getOrderActionType(refund.Action)), 1),
                          _createElementVNode("td", null, [
                            (refund.Action < 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_225, _toDisplayString(_ctx.order.CurrencySymbol) + " " + _toDisplayString(refund.Amount), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (refund.Action < 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_226, _toDisplayString(refund.Quantity), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(refund.Note), 1),
                          _createElementVNode("td", null, [
                            (refund.Action < 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                  _createElementVNode("button", {
                                    class: "btn btn-primary refun-table-font-size",
                                    onClick: ($event: any) => (_ctx.onDownloadPdfClick(refund))
                                  }, " Download Pdf File ", 8, _hoisted_228),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary refun-table-font-size",
                                    onClick: ($event: any) => (_ctx.onEmailCustomerClick(refund))
                                  }, " Email customer ", 8, _hoisted_229)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.order.Id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
          _createElementVNode("div", _hoisted_231, [
            _createElementVNode("div", _hoisted_232, [
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex", _ctx.isRefundRedoTypeOther() ? 'flex-column' : ''])
              }, [
                (!_ctx.isRedoMode)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn m-2 btn-warning",
                      onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.onRefundButtonClick()))
                    }, " Refund/Recharge "))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.isRefundRechargeMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.orderActionTypeSelected) = $event)),
                      class: "w-100 form-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderActionTypes, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.Id,
                          value: item.Id
                        }, _toDisplayString(item.Name), 9, _hoisted_234))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.orderActionTypeSelected]
                    ]),
                    _hoisted_235,
                    _createElementVNode("div", _hoisted_236, [
                      _createElementVNode("span", _hoisted_237, _toDisplayString(_ctx.order.CurrencySymbol), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.refundRechrgeTotal) = $event)),
                        name: "refundRechrgeTotal",
                        class: "form-control input-padding-left",
                        type: "number",
                        max: _ctx.refundRechrgeTotalMax,
                        min: 0,
                        pattern: "^\\d*(\\.\\d{0,2})?$",
                        onBlur: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onTotalInputBlur()))
                      }, null, 40, _hoisted_238), [
                        [_vModelText, _ctx.refundRechrgeTotal]
                      ])
                    ]),
                    _createElementVNode("span", {
                      class: "reset-refund-text",
                      onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.onResetRefundClick && _ctx.onResetRefundClick(...args)))
                    }, "Reset")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex", _ctx.isRefundRedoTypeOther() ? 'flex-column' : ''])
              }, [
                (!_ctx.isRefundRechargeMode)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn m-2 btn-warning",
                      onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.onRedoButtonClick()))
                    }, " Redo "))
                  : _createCommentVNode("", true),
                (_ctx.isRedoMode && _ctx.showUpgradeToCourier)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.shouldUpdateCourier) = $event)),
                        type: "checkbox",
                        name: "shouldUpdateCourier",
                        onChange: _cache[65] || (_cache[65] = ($event: any) => (_ctx.onChangeUpdateCourier()))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.shouldUpdateCourier]
                      ]),
                      _hoisted_240
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            (_ctx.isRefundRechargeMode || _ctx.isRedoMode)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["d-flex p-1", _ctx.isRefundRedoTypeOther() ? 'flex-column' : ''])
                }, [
                  _createElementVNode("div", _hoisted_241, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.refundRedoReasonTypeSelected) = $event)),
                      class: "w-100 form-select",
                      onChange: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.onRefundRedoReasonTypeChange && _ctx.onRefundRedoReasonTypeChange(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refundRedoReasonTypes, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.Id,
                          value: item.Id
                        }, _toDisplayString(item.Name), 9, _hoisted_242))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.refundRedoReasonTypeSelected]
                    ])
                  ]),
                  (
            _ctx.refundRedoReasonTypeSelected && _ctx.refundRedoReasonTypeSelected !== 6
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.refundRedoReasonSelected) = $event)),
                          class: "w-100 form-select"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getReasons, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.Id,
                              value: item.Id
                            }, _toDisplayString(item.Name), 9, _hoisted_244))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.refundRedoReasonSelected]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isRefundRedoTypeOther())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.refundRedoOtherReason) = $event)),
                          class: "refund-redo-reason-textarea"
                        }, null, 512), [
                          [_vModelText, _ctx.refundRedoOtherReason]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.refundRedoReasonSelected || _ctx.refundRedoOtherReason)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-warning m-2 p-1",
                        disabled: _ctx.refundRedoSaving,
                        onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.onRefundRechargeConfirmClick()))
                      }, " Confirm ", 8, _hoisted_246))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_247, [
            _createElementVNode("div", _hoisted_248, [
              _createElementVNode("table", _hoisted_249, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      colspan: _ctx.isRefundRechargeMode || _ctx.isRedoMode ? 13 : 14
                    }, _toDisplayString(_ctx.orderDisplayType), 9, _hoisted_250)
                  ])
                ]),
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_ctx.isRefundRechargeMode || _ctx.isRedoMode)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_251, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.selectAllOrderItems) = $event)),
                            type: "checkbox",
                            onChange: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.onSelectAllClick && _ctx.onSelectAllClick(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectAllOrderItems]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_252,
                    _hoisted_253,
                    _hoisted_254,
                    _hoisted_255,
                    _hoisted_256,
                    _hoisted_257,
                    _hoisted_258,
                    _hoisted_259,
                    _hoisted_260,
                    _hoisted_261,
                    _hoisted_262,
                    _hoisted_263
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.Items, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.Id
                    }, [
                      (_ctx.isRefundRechargeMode || _ctx.isRedoMode)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_264, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((item.isSelected) = $event),
                              type: "checkbox",
                              onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.onSelectOrderClick()))
                            }, null, 40, _hoisted_265), [
                              [_vModelCheckbox, item.isSelected]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.getDisplayName(item)), 1),
                        (_ctx.orderItemHasImage(item))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.ImageUrl,
                              alt: _ctx.getDisplayName(item)
                            }, null, 8, _hoisted_266))
                          : _createCommentVNode("", true),
                        (_ctx.orderItemIsNonPrintableAsset(item))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_267, _hoisted_269))
                          : _createCommentVNode("", true),
                        (_ctx.orderItemHasDownloadableAssets(item))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "btn btn-warning m-2 p-1",
                              onClick: ($event: any) => (_ctx.orderItemToggleShowAssetLinks(item))
                            }, " Assets ", 8, _hoisted_270))
                          : _createCommentVNode("", true),
                        (item.ShowAssetLinks)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                              _hoisted_272,
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    target: "_blank",
                                    href: item.DirectImageUrl
                                  }, "Original image", 8, _hoisted_273)
                                ]),
                                (_ctx.orderItemHasSignature(item))
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_274, [
                                      _createElementVNode("a", {
                                        target: "_blank",
                                        href: item.DirectSignatureUrl
                                      }, "Signature", 8, _hoisted_275)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("li", null, [
                                  _hoisted_276,
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.DirectPrintableFileUrls, (url, index) => {
                                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                                        _createElementVNode("a", {
                                          href: url,
                                          target: "_blank"
                                        }, "Copy " + _toDisplayString(index + 1), 9, _hoisted_277)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.isRedoMode)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": ($event: any) => ((item.Quantity) = $event),
                              class: "form-control",
                              type: "number",
                              min: 1,
                              max: item.OriginalQuantity
                            }, null, 8, _hoisted_278)), [
                              [_vModelText, item.Quantity]
                            ])
                          : (_openBlock(), _createElementBlock("span", _hoisted_279, _toDisplayString(item.Quantity), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (!_ctx.orderItemIsNonPrintableAsset(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_280, _toDisplayString(item.PrintType), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_281, "-"))
                      ]),
                      _createElementVNode("td", null, [
                        (!_ctx.orderItemIsNonPrintableAsset(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_282, _toDisplayString(item.Paper), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_283, "-"))
                      ]),
                      _createElementVNode("td", null, [
                        (!_ctx.orderItemIsNonPrintableAsset(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_284, _toDisplayString(`${item.PrintWidthMM}mm x ${item.PrintHeightMM}mm`), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_285, "-"))
                      ]),
                      _createElementVNode("td", null, [
                        _hoisted_286,
                        _createElementVNode("span", null, _toDisplayString(`${item.BorderTop}mm`), 1),
                        _hoisted_287,
                        _hoisted_288,
                        _createElementVNode("span", null, _toDisplayString(`${item.BorderRight}mm`), 1),
                        _hoisted_289,
                        _hoisted_290,
                        _createElementVNode("span", null, _toDisplayString(`${item.BorderBottom}mm`), 1),
                        _hoisted_291,
                        _hoisted_292,
                        _createElementVNode("span", null, _toDisplayString(`${item.BorderLeft}mm`), 1),
                        _hoisted_293
                      ]),
                      _createElementVNode("td", null, [
                        (!_ctx.orderItemIsNonPrintableAsset(item))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_294, _toDisplayString(_ctx.getPrintedArea(item)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_295, "-"))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getFinishing(item)), 1),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFinishingDetails(item), (i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(i), 1))
                        }), 128)),
                        _hoisted_296
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getItemPriceExVat(item)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getItemVat(item)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.getItemPriceInVat(item)), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("tr", null, [
                    (_ctx.isRefundRechargeMode || _ctx.isRedoMode)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_297, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.selectIncludeDelivery) = $event)),
                            type: "checkbox",
                            onChange: _cache[75] || (_cache[75] = 
//@ts-ignore
(...args) => (_ctx.onIncludeDeliveryClick && _ctx.onIncludeDeliveryClick(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.selectIncludeDelivery]
                          ]),
                          _hoisted_298
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_299,
                    _createElementVNode("td", _hoisted_300, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.orderTotal), 1),
                      _hoisted_301,
                      _createElementVNode("div", null, [
                        _hoisted_302,
                        _createElementVNode("span", null, _toDisplayString(_ctx.deliveryTotal), 1)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_303, _toDisplayString(_ctx.orderVat), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_304, _toDisplayString(_ctx.orderPriceIncludingVat), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}